import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  card: {
    "& > .MuiCardContent-root":{
      padding: "0",
    }
  },
  bgLight:{
    backgroundColor: theme.custom.color.bakgroundColor
  },
  kpiContainer: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
  },
  kpiItem: {
    padding: '16px',
    textAlign: "center",
    borderRadius: "8px",
    backgroundColor: "#f4f7fa", 
    boxShadow: "0",
    border: 'none',
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  kpiValue: {
    marginBottom: theme.spacing(0.5),
  },
  kpiLabel: {
    fontSize:' 0.875rem',
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 500,
    lineHeight: 1.57,
    color: 'rgba(0, 0, 0, 0.54)'
  }
}));